import Vue from 'vue'

import 'es6-promise/auto'
import Vuex from 'vuex'

import navigation from './modules/navigation'
import news from './modules/news'
// import actions from './actions';
// import getters from './getters';
// import mutations from './mutations';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
//   state: {
//     value: 0
// },
// getters,
// mutations,
// actions,
  modules: {
    navigation,
    news
  }
  // strict: debug
})



// WEBPACK FOOTER //
// ./src/store/store.js